import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';

import { ClaimRequestsPartialState } from './claim-requests.reducer';
import {
  ListClaimRequestByStatus,
  ListClaimRequestByStatusSuccess,
  ListClaimRequestByStatusFail,
  ClaimRequestsActionTypes,
  EditClaimRequest,
  EditClaimRequestSuccess,
  EditClaimRequestFail,
  ListClaimRequestByIdNumber,
  ListClaimRequestByIdNumberSuccess,
  ListClaimRequestByIdNumberFail,
  SearchClaimRequestByIdNumber,
  SearchClaimRequestByIdNumberSuccess,
  SearchClaimRequestByIdNumberFail,
  GetClaimRequest,
  GetClaimRequestSuccess,
  GetClaimRequestFail,
  CreateClaimRequest,
  CreateClaimRequestSuccess,
  CreateClaimRequestFail,
  ListClaimRequestByAssingee,
  ListClaimRequestByAssingeeSuccess,
  ListClaimRequestByAssingeeFail,
  ListSupervisorClaimRequestByStatus,
  ListSupervisorClaimRequestByStatusSuccess,
  ListSupervisorClaimRequestByStatusFail,
  ListClaimRequestByCurrentUser,
  ListClaimRequestByCurrentUserSuccess,
  ListClaimRequestByCurrentUserFail,
  AssignClaimRequestToVerifier,
  AssignClaimRequestToVerifierSuccess,
  AssignClaimRequestToVerifierFail
} from './claim-requests.actions';
import { ClaimRequestsService } from '../claim-requests.service';
import { map } from 'rxjs/operators';
import { Pagination } from '@ecosure-suite/shared/utils-helpers';
import {
  ClaimRequest,
  Claim,
  ClaimLine
} from '@ecosure-suite/shared/util-entities';

@Injectable({
  providedIn: 'root'
})
export class ClaimRequestsEffects {
  @Effect() edit$ = this.dataPersistence.fetch(
    ClaimRequestsActionTypes.EDIT_CLAIM_REQUEST,
    {
      run: (action: EditClaimRequest, state: ClaimRequestsPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .edit(action.payload)
          .pipe(
            map(
              (claimRequest: ClaimRequest) =>
                new EditClaimRequestSuccess(claimRequest)
            )
          );
      },

      onError: (action: EditClaimRequest, error) => {
        
        return new EditClaimRequestFail(error);
      }
    }
  );

  @Effect() listByStatus$ = this.dataPersistence.fetch(
    ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_STATUS,
    {
      run: (
        action: ListClaimRequestByStatus,
        state: ClaimRequestsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .listByStatus(action.payload, action.payload)
          .pipe(
            map(
              (claimRequests: {
                claimRequests: ClaimRequest[];
                page: Partial<Pagination>;
              }) => new ListClaimRequestByStatusSuccess(claimRequests)
            )
          );
      },

      onError: (action: ListClaimRequestByStatus, error) => {
        
        return new ListClaimRequestByStatusFail(error);
      }
    }
  );

  @Effect() listByIdNumber$ = this.dataPersistence.fetch(
    ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_ID_NUMBER,
    {
      run: (
        action: ListClaimRequestByIdNumber,
        state: ClaimRequestsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .listByIdNumber(action.payload)
          .pipe(
            map(
              (claimRequests: {
                claimRequests: ClaimRequest[];
                page: Partial<Pagination>;
              }) => new ListClaimRequestByIdNumberSuccess(claimRequests)
            )
          );
      },

      onError: (action: ListClaimRequestByIdNumber, error) => {
        
        return new ListClaimRequestByIdNumberFail(error);
      }
    }
  );

  @Effect() searchDetailedByIdNumber$ = this.dataPersistence.fetch(
    ClaimRequestsActionTypes.SEARCH_CLAIM_REQUESTS_BY_ID_NUMBER,
    {
      run: (
        action: SearchClaimRequestByIdNumber,
        state: ClaimRequestsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .searchDetailedByIdNumber(action.payload)
          .pipe(
            map(
              (claimRequests: {
                claimRequests: ClaimRequest[];
                claims: Claim[];
                claimLines: ClaimLine[];
                page: Partial<Pagination>;
              }) => new SearchClaimRequestByIdNumberSuccess(claimRequests)
            )
          );
      },

      onError: (action: SearchClaimRequestByIdNumber, error) => {
        
        return new SearchClaimRequestByIdNumberFail(error);
      }
    }
  );

  @Effect() getById$ = this.dataPersistence.fetch(
    ClaimRequestsActionTypes.GET_CLAIM_REQUEST,
    {
      run: (action: GetClaimRequest, state: ClaimRequestsPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .getById(action.payload)
          .pipe(
            map(
              (claimRequest: ClaimRequest) =>
                new GetClaimRequestSuccess(claimRequest)
            )
          );
      },

      onError: (action: GetClaimRequest, error) => {
        
        return new GetClaimRequestFail(error);
      }
    }
  );

  @Effect() create$ = this.dataPersistence.fetch(
    ClaimRequestsActionTypes.CREATE_CLAIM_REQUEST,
    {
      run: (action: CreateClaimRequest, state: ClaimRequestsPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .create(action.payload)
          .pipe(
            map(
              (claimRequest: {
                claimRequest: ClaimRequest;
                claim: Claim;
                claimLine: ClaimLine;
              }) => new CreateClaimRequestSuccess(claimRequest)
            )
          );
      },

      onError: (action: CreateClaimRequest, error) => {
        
        return new CreateClaimRequestFail(error);
      }
    }
  );

  @Effect() getAllByAssignee$ = this.dataPersistence.fetch(
    ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_ASSIGNEE,
    {
      run: (
        action: ListClaimRequestByAssingee,
        state: ClaimRequestsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .getAllByAssigneeOrStatus(action.payload)
          .pipe(
            map(
              (claimRequests: {
                claimRequests: ClaimRequest[];
                page: Partial<Pagination>;
              }) => new ListClaimRequestByAssingeeSuccess(claimRequests)
            )
          );
      },

      onError: (action: ListClaimRequestByAssingee, error) => {
        
        return new ListClaimRequestByAssingeeFail(error);
      }
    }
  );

  @Effect() getSupervisorClaimRequestsByStatus$ = this.dataPersistence.fetch(
    ClaimRequestsActionTypes.LIST_SUPERVISOR_CLAIM_REQUESTS_BY_STATUS,
    {
      run: (
        action: ListSupervisorClaimRequestByStatus,
        state: ClaimRequestsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .getAllByAssigneeOrStatus(action.payload)
          .pipe(
            map(
              (claimRequests: {
                claimRequests: ClaimRequest[];
                page: Partial<Pagination>;
              }) => new ListSupervisorClaimRequestByStatusSuccess(claimRequests)
            )
          );
      },

      onError: (action: ListSupervisorClaimRequestByStatus, error) => {
        
        return new ListSupervisorClaimRequestByStatusFail(error);
      }
    }
  );

  @Effect() getAllByCurrentUser$ = this.dataPersistence.fetch(
    ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_CURRENT_USER,
    {
      run: (
        action: ListClaimRequestByCurrentUser,
        state: ClaimRequestsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .getAllByCurrentUser(action.payload)
          .pipe(
            map(
              (claimRequests: {
                claimRequests: ClaimRequest[];
                page: Partial<Pagination>;
              }) => new ListClaimRequestByCurrentUserSuccess(claimRequests)
            )
          );
      },

      onError: (action: ListClaimRequestByCurrentUser, error) => {
        
        return new ListClaimRequestByCurrentUserFail(error);
      }
    }
  );

  @Effect() assignToVerifier$ = this.dataPersistence.fetch(
    ClaimRequestsActionTypes.ASSIGN_CLAIM_REQUEST_TO_VERIFIER,
    {
      run: (
        action: AssignClaimRequestToVerifier,
        state: ClaimRequestsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .assignToVerifier(action.payload)
          .pipe(
            map(
              (claimRequest: ClaimRequest) =>
                new AssignClaimRequestToVerifierSuccess(claimRequest)
            )
          );
      },

      onError: (action: AssignClaimRequestToVerifier, error) => {
        
        return new AssignClaimRequestToVerifierFail(error);
      }
    }
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<ClaimRequestsPartialState>,
    private service: ClaimRequestsService
  ) {}
}
